import { gql } from '@apollo/client';

export const MARK_NOTIFICATION_UNREAD_MUTATION = gql`
  mutation MarkAsUnread($id: Int!) {
    markUnread(id: $id) {
      id
    }
  }
`;